module.exports = __webpack_public_path__ + "img/bleu_cl_1969.494ea332.jpg";